export const LOGOUT_URL = `${process.env.REACT_APP_NSE_DOMAIN_URL}logout`;
export const HOME_URL = `${process.env.REACT_APP_NSE_DOMAIN_URL}dashboard`;
